module.exports = __webpack_public_path__ + "img/ring_y_s_0_1.109305d8.png";